import { Gender } from 'common/enum'
import util from 'common/util'

let constants = {
    Gender
}

util.deepFreeze(constants)

export default constants



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--2!./src/common/constants.ts